import { fetchBaseQuery } from '@reduxjs/toolkit/query';

export const baseQuery = fetchBaseQuery({
	baseUrl: '/api',
	prepareHeaders: headers => {
		const token = localStorage.getItem('access');
		if (token) {
			headers.set('Authorization', `Bearer ${token}`);
		}

		return headers;
	},
});
